import z from 'zod'
import { RecentFireRisk } from '../../../domain/entities/RecentFireRisk'
import { FireRiskEnum } from '../../../domain/enum/FireRisk.enum'

export const RecentFireRiskSchema = z
	.object({
		fk_area_monitorada: z.uuid().describe('Identificador único da fazenda'),
		nome_area_monitorada: z.string().min(3).describe('Nome legível da fazenda'),
		momento_calculo: z.preprocess((value: string) => {
			const date = new Date(value)
			return isNaN(date.getTime()) ? value : date
		}, z.date()),
		indice_formula_monte_alegre_modificada: z
			.number()
			.describe('Fator de Monitoramento de Incêndio'),
		grau_de_perigo: z.enum(FireRiskEnum),
	})
	.transform((data) => {
		return new RecentFireRisk(
			data.indice_formula_monte_alegre_modificada,
			data.momento_calculo,
			data.fk_area_monitorada,
			data.grau_de_perigo,
			data.nome_area_monitorada,
		)
	})
